import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { financesClient } from '@/api'
import { config } from '@/config'

const BASE_ROUTE = config.links.library.finances
const BASE_QUERY_KEY = financesClient.QUERY_KEY
export const useFinanceDatasets = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const financeDatasetsQuery = useQuery({
    queryKey: [...BASE_QUERY_KEY, { lockedOnly: false }],
    queryFn: () => financesClient.getAll()
  })

  const addDatasetMutation = useMutation({
    mutationFn: financesClient.addDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully added')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const cloneDatasetMutation = useMutation({
    mutationFn: financesClient.cloneDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully cloned')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const removeDatasetMutation = useMutation({
    mutationFn: financesClient.removeDataset,
    onSuccess: async () => {
      showSuccess('Dataset successfully removed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    financeDatasets: financeDatasetsQuery.data || [],
    isFetching:
      financeDatasetsQuery.isFetching && !financeDatasetsQuery.isRefetching,
    addDataset: addDatasetMutation.mutate,
    isAddDatasetInProgress: addDatasetMutation.isPending,
    cloneDataset: cloneDatasetMutation.mutate,
    isCloneDatasetInProgress: cloneDatasetMutation.isPending,
    removeDataset: removeDatasetMutation.mutate
  }
}
